var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "aria-labelledby": "shippingIcon shippingDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M14.882 4.75c.966 0 1.75.784 1.75 1.75v2.592h2c.69 0 1.319.307 1.728.822l1.437 1.738a2.71 2.71 0 01.585 1.69v2.908c0 1.155-.658 1.893-1.75 1.99v.01a2.75 2.75 0 11-5.5 0v-.018a1.765 1.765 0 01-.25.018h-5l-.005.168a2.75 2.75 0 01-5.495-.167l-1.014-.001a1.75 1.75 0 01-1.75-1.75v-10c0-.966.784-1.75 1.75-1.75h11.514zM7.132 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm10.75 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-3-10.75H3.368a.25.25 0 00-.25.25v10c0 .138.112.25.25.25h1.458a2.748 2.748 0 012.306-1.25c.965 0 1.815.498 2.305 1.25h5.445a.25.25 0 00.25-.25v-10a.25.25 0 00-.25-.25zm1.75 4.342v2.578h4.238a1.207 1.207 0 00-.276-.62l-1.4-1.691-.072-.079a.705.705 0 00-.49-.188z"
  })));
}

export default SvgShipping;